"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formErrorMessages = exports.FormErrorMessagesKey = void 0;
const LocalizedRangeValidatorFn_1 = require("./LocalizedRangeValidatorFn");
const LocalizedThresholdValidatorFn_1 = require("./LocalizedThresholdValidatorFn");
const NumberService_1 = require("./NumberService");
/**
 * Form error messages keys.
 */
var FormErrorMessagesKey;
(function (FormErrorMessagesKey) {
    FormErrorMessagesKey["REQUIRED_NUMBER"] = "REQUIRED_NUMBER";
    FormErrorMessagesKey["PARSE_NUMBER"] = "PARSE_NUMBER";
    FormErrorMessagesKey["LESS_EQUAL"] = "LESS_EQUAL";
    FormErrorMessagesKey["LESS"] = "LESS";
    FormErrorMessagesKey["GREATER_EQUAL"] = "GREATER_EQUAL";
    FormErrorMessagesKey["GREATER"] = "GREATER";
    FormErrorMessagesKey["UNKNOWN"] = "UNKNOWN";
})(FormErrorMessagesKey = exports.FormErrorMessagesKey || (exports.FormErrorMessagesKey = {}));
/**
 * A default form error messages provider that returns the translation key instead of a translation.
 * Every Application should set its own TranslationProvider that is capable of providing translations for the individual error keys.
 */
class DefaultFormErrorMessagesProvider {
    constructor() { }
    // eslint-disable-next-line
    translate(key, params) {
        return key;
    }
}
class _FormErrorMessages {
    constructor() {
        this.translationProvider = new DefaultFormErrorMessagesProvider();
    }
    /**
     * Sets a translation provider that provides form validator error messages.
     * Should be set by the application.
     *
     * @param translationProvider The form error messages translation provider.
     */
    setTranslationProvider(translationProvider) {
        this.translationProvider = translationProvider;
    }
    /**
     * Returns an error messages function for a localized threshold validator.
     *
     * @param hasGroupingSeparators Should the grouping(thousand) separators be displayed.
     * The default value is true.
     */
    errorMessageThresholdValidator(hasGroupingSeparators = true) {
        return (validationResult, validator) => {
            if (validationResult) {
                if (validationResult[LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.THRESHOLD] ||
                    validationResult[LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.THRESHOLD] === 0) {
                    let thresholdKey;
                    switch (validator.type) {
                        case LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorType.LESS:
                            thresholdKey = FormErrorMessagesKey.LESS;
                            break;
                        case LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorType.LESS_EQUAL:
                            thresholdKey = FormErrorMessagesKey.LESS_EQUAL;
                            break;
                        case LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorType.GREATER:
                            thresholdKey = FormErrorMessagesKey.GREATER;
                            break;
                        case LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorType.GREATER_EQUAL:
                            thresholdKey = FormErrorMessagesKey.GREATER_EQUAL;
                            break;
                    }
                    return this.translationProvider.translate(thresholdKey, {
                        threshold: this.toNumberString(typeof validator.threshold === 'function' ? validator.threshold() : validator.threshold, validator, hasGroupingSeparators),
                    });
                }
                else if (validationResult[LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.REQUIRED]) {
                    return this.translationProvider.translate(FormErrorMessagesKey.REQUIRED_NUMBER);
                }
                else if (validationResult[LocalizedThresholdValidatorFn_1.LocalizedThresholdValidatorErrorKey.PARSE]) {
                    return this.translationProvider.translate(FormErrorMessagesKey.PARSE_NUMBER);
                }
                return this.translationProvider.translate(FormErrorMessagesKey.UNKNOWN);
            }
            return undefined;
        };
    }
    /**
     * Returns an error messages function for a localized range validator.
     *
     * @param hasGroupingSeparators Should the grouping(thousand) separators be displayed.
     * The default value is true.
     */
    errorMessageRangeValidator(hasGroupingSeparators = true) {
        return (validationResult, validator) => {
            if (validationResult) {
                if (validationResult[LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MIN] ||
                    validationResult[LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MIN] === 0) {
                    let rangeMinKey;
                    switch (validator.type) {
                        case LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_MIN_LESS_MAX:
                            rangeMinKey = FormErrorMessagesKey.GREATER;
                            break;
                        case LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_EQUAL_MIN_LESS_MAX:
                            rangeMinKey = FormErrorMessagesKey.GREATER_EQUAL;
                            break;
                        case LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_MIN_LESS_EQUAL_MAX:
                            rangeMinKey = FormErrorMessagesKey.GREATER;
                            break;
                        case LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_EQUAL_MIN_LESS_EQUAL_MAX:
                            rangeMinKey = FormErrorMessagesKey.GREATER_EQUAL;
                            break;
                    }
                    return this.translationProvider.translate(rangeMinKey, {
                        threshold: this.toNumberString(validator.thresholdMin, validator, hasGroupingSeparators),
                    });
                }
                else if (validationResult[LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MAX] ||
                    validationResult[LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.THRESHOLD_MAX] === 0) {
                    let rangeMaxKey;
                    switch (validator.type) {
                        case LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_MIN_LESS_MAX:
                            rangeMaxKey = FormErrorMessagesKey.LESS;
                            break;
                        case LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_EQUAL_MIN_LESS_MAX:
                            rangeMaxKey = FormErrorMessagesKey.LESS;
                            break;
                        case LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_MIN_LESS_EQUAL_MAX:
                            rangeMaxKey = FormErrorMessagesKey.LESS_EQUAL;
                            break;
                        case LocalizedRangeValidatorFn_1.LocalizedRangeValidatorType.GREATER_EQUAL_MIN_LESS_EQUAL_MAX:
                            rangeMaxKey = FormErrorMessagesKey.LESS_EQUAL;
                            break;
                    }
                    return this.translationProvider.translate(rangeMaxKey, {
                        threshold: this.toNumberString(validator.thresholdMax, validator, hasGroupingSeparators),
                    });
                }
                else if (validationResult[LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.REQUIRED]) {
                    return this.translationProvider.translate(FormErrorMessagesKey.REQUIRED_NUMBER);
                }
                else if (validationResult[LocalizedRangeValidatorFn_1.LocalizedRangeValidatorErrorKey.PARSE]) {
                    return this.translationProvider.translate(FormErrorMessagesKey.PARSE_NUMBER);
                }
                return this.translationProvider.translate(FormErrorMessagesKey.UNKNOWN);
            }
            return undefined;
        };
    }
    /**
     * Transforms a number to a rounded localized number string.
     *
     * @param value A number.
     * @param validator A localized number validator function that is used to extract the rounding properties.
     * @param hasGroupingSeparators Should the grouping(thousand) separators be displayed.
     */
    toNumberString(value, validator, hasGroupingSeparators) {
        return NumberService_1.numberService.toLocalizedString(value, validator.locale, hasGroupingSeparators, validator.roundType, validator.precision, validator.significantPrecision);
    }
}
/**
 * Form error messages singleton.
 */
exports.formErrorMessages = new _FormErrorMessages();
//# sourceMappingURL=FormErrorMessages.js.map